import React, { useContext, useEffect, useState } from "react";
import {
  View,
  TouchableOpacity,
  FlatList,
  Platform,
  RefreshControl} from "react-native";
import { SafeAreaView } from "react-native-safe-area-context";
import commonStyles from "../../styles/commonStyles";
import AntDesign from "@expo/vector-icons/AntDesign";
import { getUserIdToUse } from "../../utils/getUserIdToUse";
import { ApiService } from "../../service/ApiService";

import { AgreementResponse } from "../../types/IAgreementType";
import SkeletonLoader from "../../components/SkeletonLoader";

import { useIsFocused } from "@react-navigation/native";
import { RefreshContext } from "../../contexts/refreshContext";
import OverflowTooltipText from "../../components/OverflowTooltipText";
import AppText from "../../components/AppText";

type AgreementsProps = {
  navigation: {
    navigate: (screen: string, params?: object) => void;
    goBack: () => void;
  };
};

const AgreementsPage: React.FC<AgreementsProps> = ({ navigation }) => {
  const [agreements, setAgreements] = useState<AgreementResponse[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const { refreshTrigger } = useContext(RefreshContext);
  const isFocused = useIsFocused();
  let userIdToUse: string | null;
  const fetchAgreementData = async () => {
    setLoading(true);
    try {
      userIdToUse = await getUserIdToUse();
      const response = await ApiService.get<AgreementResponse[]>(
        `portal/shareholdingAgreement/${userIdToUse}`
      );

      const data = response.data;
      console.log("data", response);
      setAgreements(data);
      setLoading(false);
    } catch (error) {
      setError("Error fetching data");
      setLoading(false);
    }
  };
  const handleRefresh = () => {
    fetchAgreementData();
  };
  useEffect(() => {
    if (isFocused && refreshTrigger > 0) {
      fetchAgreementData();
    }
  }, [refreshTrigger]);
  const renderAgreement = ({ item }: { item: AgreementResponse }) => (
    <TouchableOpacity
      style={[
        commonStyles.subContainer,
        commonStyles.p14,
        commonStyles.mlar2,
      ]}
      testID={`agreement-item-${item.id}`}
      onPress={() =>
        navigation.navigate("AgreementDetails", { agreement: item })
      }
    >
      <View>
        <View style={commonStyles.cardItemblock}>
          <OverflowTooltipText
            testID={`agreement-name-${item.id}`}
            text={item.entityName}
            style={commonStyles.detailsSubHeader}
            onPress={() =>
              navigation.navigate("AgreementDetails", { agreement: item })
            }
          />
          <AntDesign
            name="arrow-right"
            size={22}
            color="#666"
            marginBottom={4}
            testID={`agreement-arrow-icon-${item.id}`}
          />
        </View>
      </View>
    </TouchableOpacity>
  );

  return (
    <SafeAreaView
      edges={["bottom", "left", "right"]}
      style={[commonStyles.container, commonStyles.screenBottomGap]}
    >
      <View style={commonStyles.headerContainer}>
        <AppText testID="your-agreements" style={commonStyles.header}>Your Agreements</AppText>
      </View>
      {loading ? (
        <View testID="skeleton-loader">
          <SkeletonLoader rows={10} rowHeight={40}></SkeletonLoader>
        </View>
      ) : (
        <FlatList
          refreshControl={
            <RefreshControl refreshing={refreshing} onRefresh={handleRefresh} />
          }
          data={agreements}
          keyExtractor={(item) => item.id.toString()}
          renderItem={renderAgreement}
          ItemSeparatorComponent={() => <View style={{ height: 15 }} />}
          contentContainerStyle={[commonStyles.pb16, commonStyles.mt10]}
        />
      )}
    </SafeAreaView>
  );
};

export default AgreementsPage;
